module.exports = __webpack_public_path__ + "img/logo-viabrera.c0975e97.png";